import { CustomFields, Entity } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';
import { TaskStatus } from './TaskStatus';

export interface TaskUpdateProps {
  label?: string;
  comments?: string;
  barcode?: string;
  status?: TaskStatus;
  custom_fields?: CustomFields;
}

export interface ITaskProps {
  stop_id: string;
  driver_id?: string;
  label?: string;
  comments?: string;
  barcode?: string;
  status: TaskStatus;
  custom_fields?: CustomFields;

  // CRUD
  created_by?: string;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
}

export class Task extends Entity<ITaskProps> {
  get id(): string {
    return this._id!;
  }
  get stop_id(): string {
    return this.props.stop_id;
  }
  get driver_id(): string | undefined {
    return this.props.driver_id;
  }
  set driver_id(vehicle_id: string | undefined) {
    this.props.driver_id = vehicle_id;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  set label(label: string | undefined) {
    this.props.label = label;
  }
  get comments(): string | undefined {
    return this.props.comments;
  }
  set comments(comments: string | undefined) {
    this.props.comments = comments;
  }
  get barcode(): string | undefined {
    return this.props.barcode;
  }
  set barcode(barcode: string | undefined) {
    this.props.barcode = barcode;
  }
  get status(): TaskStatus {
    return this.props.status;
  }
  set status(status: TaskStatus) {
    this.props.status = status;
  }
  get custom_fields(): CustomFields | undefined {
    return this.props.custom_fields;
  }
  set custom_fields(custom_fields: CustomFields | undefined) {
    this.props.custom_fields = custom_fields;
  }
  get created_by(): string | undefined {
    return this.props.created_by;
  }
  get created_at(): Date | undefined {
    return this.props.created_at;
  }
  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }
  get deleted_at(): Date | undefined {
    return this.props.deleted_at;
  }

  update(props: TaskUpdateProps) {
    removeEmpty(props);
    if (props.label) this.props.label = props.label;
    if (props.comments) this.props.comments = props.comments;
    if (props.barcode) this.props.barcode = props.barcode;
    if (props.status) this.props.status = props.status;
    if (props.custom_fields) this.props.custom_fields = props.custom_fields;
    this.props.updated_at = new Date();
  }

  private constructor(props: ITaskProps, id?: string) {
    super(props, id);
  }

  static create(props: ITaskProps, id?: string) {
    return new Task(props, id);
  }
}
